// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconLinearFilterSquare = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.43984 4.43332H10.5532C10.9798 4.43332 11.3265 4.77999 11.3265 5.20665V6.05999C11.3265 6.37332 11.1332 6.75999 10.9398 6.95332L9.27317 8.42665C9.03984 8.61999 8.8865 9.00665 8.8865 9.31999V10.9867C8.8865 11.22 8.73317 11.5267 8.53984 11.6467L7.99984 11.9867C7.49317 12.3 6.79984 11.9467 6.79984 11.3267V9.27332C6.79984 8.99999 6.6465 8.65332 6.4865 8.45999L5.01317 6.90665C4.81984 6.71999 4.6665 6.36665 4.6665 6.13332V5.24665C4.6665 4.77999 5.01317 4.43332 5.43984 4.43332Z',
      stroke: 'currentColor',
      strokeMiterlimit: '10',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.00016 14.6667H10.0002C13.3335 14.6667 14.6668 13.3333 14.6668 10V6.00001C14.6668 2.66668 13.3335 1.33334 10.0002 1.33334H6.00016C2.66683 1.33334 1.3335 2.66668 1.3335 6.00001V10C1.3335 13.3333 2.66683 14.6667 6.00016 14.6667Z',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconLinearFilterSquare };
